<div class="modal-header">
  <h5 class="modal-title">
    <i class="fal fa-money-check"></i><ng-container>&nbsp;</ng-container
    ><ng-container i18n>Update Quote Details</ng-container>
  </h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <app-update-quote-external
    *ngIf="external || !data.inquiry?.bookingEngine"
    [inquiry]="data.inquiry"
    (close)="close()"
  ></app-update-quote-external>
  <app-update-quote-internal
    *ngIf="!external && !!data.inquiry?.bookingEngine"
    [inquiry]="data.inquiry"
    (close)="close()"
  ></app-update-quote-internal>
</div>
